<template>
  <el-row>
    <div class="commonTitle m20">취급업무</div>
    <div class="news">
      <div class="news-left">
        <div
            class="news-left-item flex al-cn f16 pl30"
            @click="tabClick(item)"
            :style="{background:queryParams.categoryId == item.category_id ? '#E03629' : '',
            color:queryParams.categoryId == item.category_id ? '#fff' : '#111'}"
            v-for="(item,index) in screenList"
            :key="index">
          {{ item.name }}
        </div>
      </div>
      <div class="select mb20">
        <el-select v-model="queryParams.categoryId" placeholder="请选择" @change="newsList">
          <el-option
              v-for="item in screenList"
              :key="item.category_id"
              :label="item.name"
              :value="item.category_id">
          </el-option>
        </el-select>
      </div>
      <div class="borderTop">
        <el-table class="table" :data="tableData" @row-click="detailsClick">
          <el-table-column type="index" width="50" label="序列"  ></el-table-column>
          <el-table-column prop="title" label="标题"  ></el-table-column>
          <el-table-column prop="create_time" label="日期" width="200"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                  size="small"
                  type="text"
                  @click="detailsClick(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="news-list ptb15 borderBeee" v-for="(item,index) in tableData" :key="index"
             @click="detailsClick(item)">
          <p>{{ item.title }}</p>
          <p class="time mt10">{{ item.create_time }}</p>
        </div>
        <div class="flex ju-cn mt20 mb40">
          <pagination
              class="pagination"
              background
              v-show="total > 0"
              :total="total"
              layout="prev, pager, next"
              :page.sync="queryParams.page"
              :pagesize.sync="queryParams.pageSize"
              @pagination="newsList"/>
        </div>
      </div>
    </div>
  </el-row>
</template>
<script>

import {newsList, newsCategoryList,} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      queryParams: {
        page: 1,
        pageSize: 10,
        categoryId: ''
      },
      total: 0,
      value: '',
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      screenList: []
    }
  },
  created() {

  },
  mounted() {
    this.newsCategoryList() // 新闻分类
  },
  methods: {
    detailsClick(item) {
      this.$router.push({
        path: '/exhibitionInformation',
        query: {
          id: item.article_id
        }
      })
    },
    rowClick(row, event, column) {
      console.log(row, event, column)
      this.$router.push({
        path: '/exhibitionInformation',
        query: {
          id: item.article_id
        }
      })
    },
    // 点击tab切换
    tabClick(item) {
      this.queryParams.categoryId = item.category_id
      this.newsList()
    },
    // 新闻分类
    newsCategoryList() {
      newsCategoryList().then(res => {
        if (res.status === 200) {
          this.screenList = res.data.list
          this.queryParams.categoryId = res.data.list[0].category_id
          this.newsList()
        }
      })
    },
    // 新闻列表
    newsList() {
      newsList(this.queryParams).then(res => {
        if (res.status === 200) {
          this.tableData = res.data.list.data
          this.total = res.data.list.total
        }
      })
    },
  }
}
</script>



<style scoped lang="scss">
.news {
  &-list {
    font-size: 14px;
    color: #111111;

    .time {
      font-size: 12px;
      color: #666666;
    }
  }
}
@media (max-width: 750px) {
  .table {
    display: none;
  }
  .news-left {
    display: none;
  }
}

@media (min-width: 750px) {
  .table {
    min-width: 60vw;
  }
  .news {
    display: flex;

    &-left {
      width: 250px;
      margin-right: 20px;

      &-item {
        height: 52px;
        line-height: 52px;
        cursor: pointer;
        min-width: 200px; // 最小宽度保障
        &:hover {
          background: #ffbdb8;
        }
      }
    }

    .select {
      display: none;
    }

    &-list {
      //隐藏
      display: none;
    }
  }
}

@media (min-width: 1980px) {
  .table {
    min-width: 45vw;
  }
  .news {
    display: flex;

    &-left {
      width: 250px;
      margin-right: 20px;

      &-item {
        height: 52px;
        line-height: 52px;
        cursor: pointer;
        min-width: 200px; // 最小宽度保障
        &:hover {
          background: #ffbdb8;
        }
      }
    }

    .select {
      display: none;
    }

    &-list {
      //隐藏
      display: none;
    }
  }
}
</style>
